import React from 'react';

import Permissions from '@/common/permissions';
import ActivityLog from '@/modules/ActivityLog';
import { useHasAccess } from '@/modules/core';
import ModuleWrapper from '@/modules/plan/ModuleWrapper';

import { HEALTH_PLAN_MODULES } from '../../HealthPlan.constants';

const ActivityLogSection: React.FC = () => {
  const hasActivityLog = useHasAccess([{ permission: Permissions.VIEW_PROFILE }]);
  if (!hasActivityLog) return;

  return (
    <ModuleWrapper
      testId="activity-log"
      anchorId={HEALTH_PLAN_MODULES.ACTIVITY_LOG}
      title="Activity Log"
      expandless
      defaultExpandedValue={false}
    >
      <ActivityLog />
    </ModuleWrapper>
  );
};

export default React.memo(ActivityLogSection);
